var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-tabbar', {
    attrs: {
      "active-color": "#4263EB",
      "inactive-color": "#ACBBF3"
    },
    model: {
      value: _vm.active,
      callback: function ($$v) {
        _vm.active = $$v;
      },
      expression: "active"
    }
  }, [_c('van-tabbar-item', {
    attrs: {
      "replace": "",
      "to": "/"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function (props) {
        return [_c('img', {
          staticClass: "tabbar_icon",
          attrs: {
            "src": props.active ? _vm.activehome : _vm.inactivehome
          }
        })];
      }
    }])
  }, [_c('span', {
    staticClass: "tabbar_title"
  }, [_vm._v("首页")])]), _c('van-tabbar-item', {
    attrs: {
      "replace": "",
      "to": "/flow"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function (props) {
        return [_c('img', {
          staticClass: "tabbar_icon",
          attrs: {
            "src": props.active ? _vm.activeflow : _vm.inactiveflow
          }
        })];
      }
    }])
  }, [_c('span', {
    staticClass: "tabbar_title"
  }, [_vm._v(" 流水查询")])]), _c('van-tabbar-item', {
    attrs: {
      "replace": "",
      "to": "/my"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function (props) {
        return [_c('img', {
          staticClass: "tabbar_icon",
          attrs: {
            "src": props.active ? _vm.activeMy : _vm.inactiveMy
          }
        })];
      }
    }])
  }, [_c('span', {
    staticClass: "tabbar_title"
  }, [_vm._v("我的")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };